const redirectSelector = state => state.project.update.redirect

export {
  redirectSelector,
}
